import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "summary-section",
  "data-type": "borrower"
}
const _hoisted_2 = { class: "summary-section-header sc-header" }
const _hoisted_3 = { class: "sc-initials-circle" }
const _hoisted_4 = { class: "summary-section-content" }
const _hoisted_5 = { class: "sc-label" }
const _hoisted_6 = { class: "sc-value" }
const _hoisted_7 = {
  key: 1,
  class: "summary-section",
  "data-type": "no-coborrower"
}

import { ref, computed } from "vue";
import { BorrowerVM } from "@/types/certifications";


export default /*@__PURE__*/_defineComponent({
  __name: 'Borrower',
  props: {
    borrower: {},
    coborrowerDisplayName: {}
  },
  setup(__props: any) {

const props = __props;

const isMasked = ref<boolean>(true);

const nationalIdNumberDisplay = computed<string>(() =>
  isMasked.value
    ? props.borrower?.nationalIdNumberMasked || ""
    : props.borrower?.nationalIdNumber || ""
);

function toggleNationalIdNumber() {
  isMasked.value = !isMasked.value;
}

const data = computed(() => [
  {
    name: "nationalIdNumber",
    label: props.borrower?.nationalIdNumberLabel || "SSN",
    title: null,
    value: nationalIdNumberDisplay.value,
  },
  {
    name: "dateOfBirth",
    label: "Birthdate",
    title: null,
    value: props.borrower?.birthdate || "",
  },
  {
    name: "address",
    label: "Address",
    title: null,
    value: props.borrower?.addressDisplay || "",
  },
  {
    name: "phoneNumber",
    label: "Phone",
    title: null,
    value: props.borrower?.phoneNumberDisplay || "",
  },
  {
    name: "emailAddress",
    label: "Email",
    title: null,
    value: props.borrower?.emailAddress || "",
  },
  {
    name: "username",
    label: "User",
    title: null,
    value: props.borrower?.username || "",
  },
]);

return (_ctx: any,_cache: any) => {
  return (__props.borrower)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.borrower?.initials || "NN"), 1),
          _createElementVNode("div", null, _toDisplayString(__props.borrower?.fullName || ""), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (field) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: field.name
              }, [
                _createElementVNode("th", _hoisted_5, _toDisplayString(field.label || ""), 1),
                _createElementVNode("td", _hoisted_6, [
                  _createTextVNode(_toDisplayString(field.value || "") + " ", 1),
                  (
                field.name === 'nationalIdNumber' &&
                __props.borrower?.showNationalIdNumberToggle
              )
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["inline-icon", isMasked.value ? 'icon-eye' : 'icon-eye-slash']),
                        "data-type": "toggle",
                        onClick: toggleNationalIdNumber
                      }, null, 2))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", null, " Loan does not have a " + _toDisplayString(__props.coborrowerDisplayName || "Co-Applicant"), 1)
      ]))
}
}

})